import React, {useEffect, useState} from "react";
import CommonSection from "../../components/Layout/CommonSection";
import {ReactComponent as Phone} from "../../assets/phone-number.svg";
import {ReactComponent as Mail} from "../../assets/mail.svg";
import {ReactComponent as Location} from "../../assets/location.svg";
import {ReactComponent as Time} from "../../assets/time.svg";
import {ReactComponent as Calendar} from "../../assets/calendar.svg";
// import phone from "../../assets/phone.svg";
// import User from "../../assets/user.svg";
// import Email from "../../assets/email.svg";
import InputMask from "react-input-mask";
// import Messege from "../../assets/messege.svg";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {sendContact} from "../../redux/actions/actions";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import aos from "aos";

export default function Connection() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {t} = useTranslation();
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone_number, setPhoneNumber] = useState("");
	const [message, setMessage] = useState("");
	
	const {location} = useSelector((state) => state.location);
	
	const handleSubmit = (e) => {
		e.preventDefault();
		if (!name) {
			toast.error("Ismingiz yoki tashkilot nomini kiritmadingiz!");
		} else if (!email) {
			toast.error("Pochtangizni kiritmadingiz!");
		} else if (!phone_number) {
			toast.error("Telefon raqamingizni kiritmadingiz!");
		} else if (!message) {
			toast.error("Xabarni kiritmadingiz!");
		} else {
			dispatch(sendContact({full_name: name, email, phone_number, message}));
			toast.success("Xabaringiz yuborildi tez orada bo'glanamiz");
			setName("");
			setEmail("");
			setPhoneNumber("");
			setMessage("");
		}
	};
	
	useEffect(() => {
		aos.init();
		window.scrollTo(0, 0);
	}, []);
	
	return (
		<>
			<div>
				<CommonSection title={t("contact")} breadCrumb={t("contact")}/>
				<div
					className="container mx-auto pt-8"
					data-aos={"fade-up"}
					data-aos-duration={"2000"}
				>
					<h2 className="text-logo mb-8 text-4xl font-medium" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						{t("contact")}
					</h2>
					
					<div className="mb-24" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						<div className="box py-6 flex gap-14 flex-wrap xl:gap-7">
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Location className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("address")}</dt>
									<dd className="text-lg w-72">
										{t('address_footer')}
									</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Phone className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("phone")}</dt>
									<dd className="text-lg w-72">+998 71-211-88-88</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Time className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("work-day")}</dt>
									<dd className="text-lg w-74">{t("work_day")}</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Mail className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("pochta")}</dt>
									<dd className="text-lg w-72">100187</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Mail className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">E-mail:</dt>
									<dd className="text-lg w-72">info@unicon.uz</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Calendar className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("relax")}</dt>
									<dd className="text-lg w-72">{t("relax_day")}</dd>
								</dl>
							</div>
						</div>
					</div>
					
					<h2 className="text-logo mb-8 text-4xl font-medium" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						{t("devonxona")}
					</h2>
					
					<div className="mb-24" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						<div className="box py-6 flex gap-14 flex-wrap xl:gap-7">
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Phone className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("trust_phone")}</dt>
									<dd className="text-lg w-72">+998 71 208 81 94</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Mail className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">E-mail:</dt>
									<dd className="text-lg w-72">
										devonxona@unicon.uz <br/> unicon@exat.uz
									</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Time className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("work-day")}</dt>
									<dd className="text-lg w-74">{t("work_day")}</dd>
								</dl>
							</div>
						</div>
					</div>
					
					<h2 className="text-logo mb-8 text-4xl font-medium" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						{t("anti_corruption")}
					</h2>
					
					<div className="mb-24" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						<div className="box py-6 flex gap-14 flex-wrap xl:gap-7">
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Phone className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("trust_phone")}</dt>
									<dd className="text-lg w-72">+998 71-211-88-88 (1052)</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Mail className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">E-mail:</dt>
									<dd className="text-lg w-72">anticor@unicon.uz</dd>
								</dl>
							</div>
							
							<div className="py-4 px-5 flex w-[30%] gap-5 c-col xl:w-[45%]">
								<Time className="w-[23px] object-contain h-[23px]"/>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">{t("work-day")}</dt>
									<dd className="text-lg w-74">{t("work_day")}</dd>
								</dl>
							</div>
						</div>
					</div>
					
					<h2 className="text-logo mb-8 text-4xl font-medium" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						{t("see_social")}
					</h2>
					
					<div className="mb-24" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						<div className="box py-6 flex gap-14 flex-wrap xl:gap-7">
							<div className="py-4 px-5 flex w-[21%] gap-5 c-col xl:w-[45%]">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24"
									height="24"
								>
									<path
										d="M12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM8.89113 13.1708L6.39308 12.3911C5.85317 12.2255 5.84996 11.854 6.51397 11.5871L16.247 7.82754C16.8115 7.59644 17.1325 7.88842 16.9495 8.61641L15.2917 16.4377C15.1763 16.9941 14.8407 17.1266 14.3759 16.8698L11.825 14.9823L10.6361 16.1297C10.5139 16.2476 10.4145 16.3489 10.2273 16.3743C10.04 16.3996 9.88564 16.3442 9.77337 16.0337L8.90378 13.1628L8.89113 13.1708Z"
										fill="rgba(70,146,221,1)"
									></path>
								</svg>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">
										<a target="_blank" href="https://t.me/uniconcompany">
											Telegram
										</a>
									</dt>
								</dl>
							</div>
							<div className="py-4 px-5 flex w-[21%] gap-5 c-col xl:w-[45%]">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24"
									height="24"
								>
									<path
										d="M12.001 2C6.47813 2 2.00098 6.47715 2.00098 12C2.00098 16.9913 5.65783 21.1283 10.4385 21.8785V14.8906H7.89941V12H10.4385V9.79688C10.4385 7.29063 11.9314 5.90625 14.2156 5.90625C15.3097 5.90625 16.4541 6.10156 16.4541 6.10156V8.5625H15.1931C13.9509 8.5625 13.5635 9.33334 13.5635 10.1242V12H16.3369L15.8936 14.8906H13.5635V21.8785C18.3441 21.1283 22.001 16.9913 22.001 12C22.001 6.47715 17.5238 2 12.001 2Z"
										fill="rgba(70,146,221,1)"
									></path>
								</svg>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">
										<a target="_blank" href="https://www.facebook.com/uniconuz">
											Facebook
										</a>
									</dt>
								</dl>
							</div>
							<div className="py-4 px-5 flex w-[21%] gap-5 c-col xl:w-[45%]">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24"
									height="24"
								>
									<path
										d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"
										fill="rgba(70,146,221,1)"
									></path>
								</svg>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">
										<a
											target="_blank"
											href="https://www.instagram.com/unicon.uz_official/"
										>
											Instagram
										</a>
									</dt>
								</dl>
							</div>
							<div className="py-4 px-5 flex w-[21%] gap-5 c-col xl:w-[45%]">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
								>
									<rect x="2" y="6" width="20" height="12" rx="3" fill="#4692DD"/>
									<path d="M10 9V15L15 12L10 9Z" fill="white"/>
								</svg>
								<dl className="flex flex-col gap-3">
									<dt className="font-bold text-lg mb-4">
										<a
											target="_blank"
											href="https://www.youtube.com/@unicon.uz_official"
										>
											You tube
										</a>
									</dt>
								</dl>
							</div>
						</div>
					</div>
					
					<div className="box mb-10" data-aos="zoom-out-up" data-aos-duration={"1000"}>
						<div className="title w-2/4 xs:w-full">
							<h1 className="text-logo font-bold text-3xl mb-3">{t("call")}</h1>
							<p className="text-grey">{t("call-text")}</p>
						</div>
						<div className="content flex justify-between mt-5 md:flex-wrap">
							<div
								className="left w-[48%] md:w-full"
								style={{boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)"}}
							>
								<form
									onSubmit={handleSubmit}
									className="w-full md:w-full flex flex-wrap justify-between gap-5 py-5 px-8"
								>
									<label
										htmlFor="name"
										className="flex flex-col gap-2 w-[48%] lg:w-full md:w-full xs:w-full"
									>
										<span className="text-grey">{t("name")}</span>
										<input
											value={name}
											onChange={(e) => setName(e.target.value)}
											type="text"
											id="name"
											className="border border-logo rounded-lg py-2 px-4"
										/>
									</label>
									<label
										htmlFor="phone"
										className="flex flex-col gap-2 w-[48%] lg:w-full md:w-full xs:w-full"
									>
										<span className="text-grey">{t("phone")}</span>
										<InputMask
											mask={"+999 (99) 999 99 99"}
											value={phone_number}
											onChange={(e) => setPhoneNumber(e.target.value)}
											className="border border-logo rounded-lg py-2 px-4"
											type="tel"
											name="phone_number"
										/>
									</label>
									<label htmlFor="email" className="flex flex-col gap-2 w-full">
										<span className="text-grey">{t("email")}</span>
										<input
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											type="text"
											id="email"
											className="border border-logo rounded-lg py-2 px-4"
										/>
									</label>
									<label
										htmlFor="textarea"
										className="flex flex-col gap-2 w-full"
									>
										<span className="text-grey">{t("reference-text")}</span>
										<textarea
											value={message}
											onChange={(e) => setMessage(e.target.value)}
											id="textarea"
											className="border border-logo rounded-lg py-2 px-4"
										/>
									</label>
									<button className="bg-logo text-white px-4 py-2 hover:bg-hover duration-300 ml-auto">
										{t("send")}
									</button>
								</form>
							</div>
							<div className="flex flex-col justify-between right w-1/2 md:w-full">
								<div
									className="flex items-center gap-5 overflow-hidden md:mt-5"
									style={{boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)"}}
								>
                  <span className="bg-logo text-white py-6 px-6 text-5xl xs:text-2xl">
                    <i className="ri-phone-fill"></i>
                  </span>
									<div>
										<h1>{t("phone")}</h1>
										<a href="tel:+998712118888">+998 71-211-88-88</a>
									</div>
								</div>
								<div
									className="flex items-center gap-5 mt-5 overflow-hidden"
									style={{boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)"}}
								>
                  <span className="bg-logo text-white py-6 px-6 text-5xl xs:text-2xl">
                    <i className="ri-map-pin-fill"></i>
                  </span>
									<div>
										<h1>{t("address")}</h1>
										<p>{t("address_footer")}</p>
									</div>
								</div>
								<div
									className="flex items-center gap-5 mt-5 overflow-hidden"
									style={{boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)"}}
								>
                  <span className="bg-logo text-white py-6 px-6 text-5xl xs:text-2xl">
                    <i className="ri-mail-line"></i>
                  </span>
									<div>
										<h1>{t("email")}</h1>
										<a href="mailto:info@unicon.uz">
											<span>info@unicon.uz</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					{/* <div className="connection">
            <h1 className="text-4xl text-logo text-center mb-8">
              {t("if-quest")}
              <br />
              <b>{t("call")}</b>
            </h1>
            <p className="text-center mb-10">
              {t("contact-text")}
              <br />
              {t("contact-text2")}
            </p>
            <form
              onSubmit={handleSubmit}
              className="flex flex-wrap gap-5 md:gap-3 mb-20"
            >
              <div className="relative w-[32%] flex-grow sm:w-full hover:scale-105 duration-300">
                <img
                  width={"18px"}
                  src={User}
                  alt="user icon"
                  className="absolute top-5 left-3 md:top-3"
                />
                <input
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="hover:shadow-xl text-xl  px-4 py-4  border-none rounded-lg  md:px-2 md:py-2 w-full pl-9 md:pl-9"
                  style={{ boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)" }}
                  type="text"
                  placeholder={t("organization-name")}
                  name="name"
                />
              </div>

              <div className="relative w-[32%] flex-grow sm:w-full hover:scale-105 duration-300">
                <img
                  width={"18px"}
                  src={Email}
                  alt="email icon"
                  className="absolute top-5 left-3 md:top-3"
                />
                <input
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="hover:shadow-xl text-xl  px-4 py-4 border-none rounded-lg  md:px-2 md:py-2 w-full pl-9 md:pl-9"
                  style={{ boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)" }}
                  type="email"
                  placeholder={t("email")}
                  name="email"
                />
              </div>

              <div className="relative w-[32%] flex-grow sm:w-full hover:scale-105 duration-300">
                <img
                  width={"18px"}
                  src={phone}
                  alt="phone icon"
                  className="absolute top-5 left-3 md:top-3"
                />
                <InputMask
                  className="hover:shadow-xl text-xl  px-4 py-4 border-none rounded-lg  md:px-2 md:py-2 w-full pl-9 md:pl-9"
                  mask={"+999 (99) 999 99 99"}
                  placeholder={t("phone")}
                  value={phone_number}
                  style={{ boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)" }}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  type="tel"
                  name="phone_number"
                />
              </div>

              <div className="relative w-[66%] flex-grow sm:w-full hover:scale-105 duration-300">
                <img
                  width={"18px"}
                  src={Messege}
                  alt="messege icon"
                  className="absolute top-5 left-3 md:top-3"
                />
                <textarea
                  required
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="hover:shadow-xl text-xl  px-4 py-4 border-none rounded-lg w-full h-full md:px-2 md:py-2 pl-9 md:pl-9"
                  style={{ boxShadow: "0 0 20px 0 rgb(24 50 67 / 12%)" }}
                  placeholder="Xabar"
                  name={t("message")}
                />
              </div>

              <div className="flex flex-col w-[32%] flex-grow items-start">
                <button
                  className="px-6 text-xl py-2 bg-logo border-logo border-2 border-solid hover:bg-white  text-white hover:text-logo font-semibold rounded-full mt-3  md:px-2 md:mt-2 transition"
                  type={"submit"}
                >
                  {t("send")}
                </button>
              </div>
            </form>
          </div> */}
				</div>
				<div className="map" data-aos="zoom-out-up" data-aos-duration={"1000"}>
					<iframe
						src={location === "uz" || location === "en" ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1331.4883954426405!2d69.36445685971903!3d41.33051455128123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38aef5fab8250075%3A0x928c108393b21d4c!2z0JPQo9CfICJVTklDT04uVVoi!5e0!3m2!1sen!2s!4v1653977855506!5m2!1sen!2s"
							: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2996.0103223596566!2d69.3651021!3d41.330388899999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38aef4ad010dd425%3A0x5a98eb519ac9451!2z0JPQo9CfINCm0LXQvdGC0YAg0L3QsNGD0YfQvdC-LdGC0LXRhdC90LjRh9C10YHQutC40YUg0Lgg0LzQsNGA0LrQtdGC0LjQvdCz0L7QstGL0YUg0LjRgdGB0LvQtdC00L7QstCw0L3QuNC5ICJVTklDT04uVVoi!5e0!3m2!1sru!2s!4v1709300162130!5m2!1sru!2s"}
						width="100%"
						height="600"
						style={{border: "0"}}
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
						title="unicon"
					/>
				</div>
			</div>
		</>
	);
}
